var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CDDC39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 8.02466H11.8332C9.33317 8.02466 7.6665 9.69132 7.6665 12.1913V17.1913C7.6665 19.6913 9.33317 21.358 11.8332 21.358V23.133C11.8332 23.7997 12.5748 24.1997 13.1248 23.8247L16.8332 21.358H20.1665C22.6665 21.358 24.3332 19.6913 24.3332 17.1913V12.1913C24.3332 9.69132 22.6665 8.02466 20.1665 8.02466ZM15.9998 18.1663C15.6498 18.1663 15.3748 17.883 15.3748 17.5413C15.3748 17.1997 15.6498 16.9163 15.9998 16.9163C16.3498 16.9163 16.6248 17.1997 16.6248 17.5413C16.6248 17.883 16.3498 18.1663 15.9998 18.1663ZM17.0498 14.708C16.7248 14.9247 16.6248 15.0663 16.6248 15.2997V15.4747C16.6248 15.8163 16.3415 16.0997 15.9998 16.0997C15.6582 16.0997 15.3748 15.8163 15.3748 15.4747V15.2997C15.3748 14.333 16.0832 13.858 16.3498 13.6747C16.6582 13.4663 16.7582 13.3247 16.7582 13.108C16.7582 12.6913 16.4165 12.3497 15.9998 12.3497C15.5832 12.3497 15.2415 12.6913 15.2415 13.108C15.2415 13.4497 14.9582 13.733 14.6165 13.733C14.2748 13.733 13.9915 13.4497 13.9915 13.108C13.9915 11.9997 14.8915 11.0997 15.9998 11.0997C17.1082 11.0997 18.0082 11.9997 18.0082 13.108C18.0082 14.058 17.3082 14.533 17.0498 14.708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.49ee5cd55e69a8b7f581a8105d78c3d7.svg";
export { ForwardRef as ReactComponent };